
import { Vue, Component, Prop } from 'vue-property-decorator'
  @Component
export default class HistoryNoSign extends Vue {
    @Prop() signData: any
    @Prop() history_sign_time: string

    mounted(){}
}

